import React from 'react';
import NavBar from '../Components/NavBar'
import Front from '../Components/Front'
import './Home.css'

class Home extends React.Component{
    constructor(props){
        super(props)
        this.state = {}
    }
    render(){
        return(
            <div>
                <Front />
            </div>
        )
    }
}

export default Home;